// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GateRequestModal_backdrop__92VtP {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.GateRequestModal_modal__eCCWr {
  width: 760px;
  max-width: calc(100% - 32px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  overflow: hidden;
}

.GateRequestModal_header__wG9Nb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.GateRequestModal_title__-NNcL {
    color: var(--Slate-700, #334155);

    /* Inter/Body xl/Body xl - semibold */
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 150% */
}

.GateRequestModal_content__FuQ4l {
  padding: 20px 24px;
}

.GateRequestModal_section__mG1TX {
  margin-bottom: 20px;
}

.GateRequestModal_sectionTitle__62dN7 {
    color: var(--Gray-900, #111827);

    /* Inter/Body md/Body md - semibold */
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    margin-bottom: 24px;
}

.GateRequestModal_sectionReason__ZFGqV {

    color: var(--Slate-800, #1E293B);

    /* Inter/Body small/Body small - medium */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
}

.GateRequestModal_required__fBH2m {
  color: #dc2626;
  margin-left: 4px;
}

.GateRequestModal_infoGrid__sg0pR {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px 24px;
}

.GateRequestModal_label__MzyO9 {
    color: var(--Gray-500, #6B7280);

    /* Inter/Body small/Body small - regular */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    margin-bottom: 4px;
    margin-top: 0px;
}

.GateRequestModal_value__nAxEB {
    color: var(--Gray-800, #1F2937);

    /* Inter/Body small/Body small - medium */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    margin: 0;
}

.GateRequestModal_fieldColumn__I7siU {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.GateRequestModal_timeGrid__4GcWL {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.GateRequestModal_roundedInput__8\\+fV9 .MuiOutlinedInput-root {
  border-radius: 12px;
}

.GateRequestModal_roundedInput__8\\+fV9 .MuiOutlinedInput-notchedOutline {
  border-color: #d1d5db;
}



.GateRequestModal_footer__K7FMv {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
}

.GateRequestModal_cancelBtn__GKDBk {
  color: #111827;
  border-color: #e5e7eb;
  background: #ffffff;
  border-radius: 10px;
  height: 40px;
  padding: 0 16px;
  font-weight: 500;
  text-transform: none;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.GateRequestModal_submitBtn__-HW5K {
  background: #5b3df4;
  color: #ffffff !important;
  border-radius: 10px;
  height: 40px;
  padding: 0 16px;
  font-weight: 500;
  text-transform: none;
  box-shadow: 0 2px 6px rgba(91, 61, 244, 0.3);
  transition: background-color 0.2s ease, transform 0.05s ease, box-shadow 0.2s ease;
}

.GateRequestModal_cancelBtn__GKDBk:hover {
  background: #f3f4f6;
  border-color: #e5e7eb;
}

.GateRequestModal_submitBtn__-HW5K:hover {
  background: #4f33e1;
  box-shadow: 0 4px 10px rgba(79, 51, 225, 0.35);
}

.GateRequestModal_submitBtn__-HW5K:active {
  transform: translateY(1px);
}


.GateRequestModal_leaveParent__yyeDT{
  display: flex;
  flex-direction: column;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/views/SuperMostAdmin/GatePass/components/GateRequestModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;IACI,gCAAgC;;IAEhC,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,+BAA+B;;IAE/B,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;;IAEhC,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;IACI,+BAA+B;;IAE/B,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,+BAA+B;;IAE/B,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,SAAS;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.modal {\n  width: 760px;\n  max-width: calc(100% - 32px);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.12);\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.title {\n    color: var(--Slate-700, #334155);\n\n    /* Inter/Body xl/Body xl - semibold */\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px; /* 150% */\n}\n\n.content {\n  padding: 20px 24px;\n}\n\n.section {\n  margin-bottom: 20px;\n}\n\n.sectionTitle {\n    color: var(--Gray-900, #111827);\n\n    /* Inter/Body md/Body md - semibold */\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    margin-bottom: 24px;\n}\n\n.sectionReason {\n\n    color: var(--Slate-800, #1E293B);\n\n    /* Inter/Body small/Body small - medium */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px; /* 142.857% */\n}\n\n.required {\n  color: #dc2626;\n  margin-left: 4px;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px 24px;\n}\n\n.label {\n    color: var(--Gray-500, #6B7280);\n\n    /* Inter/Body small/Body small - regular */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin-bottom: 4px;\n    margin-top: 0px;\n}\n\n.value {\n    color: var(--Gray-800, #1F2937);\n\n    /* Inter/Body small/Body small - medium */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n}\n\n.fieldColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.timeGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.roundedInput :global(.MuiOutlinedInput-root) {\n  border-radius: 12px;\n}\n\n.roundedInput :global(.MuiOutlinedInput-notchedOutline) {\n  border-color: #d1d5db;\n}\n\n\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.cancelBtn {\n  color: #111827;\n  border-color: #e5e7eb;\n  background: #ffffff;\n  border-radius: 10px;\n  height: 40px;\n  padding: 0 16px;\n  font-weight: 500;\n  text-transform: none;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.submitBtn {\n  background: #5b3df4;\n  color: #ffffff !important;\n  border-radius: 10px;\n  height: 40px;\n  padding: 0 16px;\n  font-weight: 500;\n  text-transform: none;\n  box-shadow: 0 2px 6px rgba(91, 61, 244, 0.3);\n  transition: background-color 0.2s ease, transform 0.05s ease, box-shadow 0.2s ease;\n}\n\n.cancelBtn:hover {\n  background: #f3f4f6;\n  border-color: #e5e7eb;\n}\n\n.submitBtn:hover {\n  background: #4f33e1;\n  box-shadow: 0 4px 10px rgba(79, 51, 225, 0.35);\n}\n\n.submitBtn:active {\n  transform: translateY(1px);\n}\n\n\n.leaveParent{\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `GateRequestModal_backdrop__92VtP`,
	"modal": `GateRequestModal_modal__eCCWr`,
	"header": `GateRequestModal_header__wG9Nb`,
	"title": `GateRequestModal_title__-NNcL`,
	"content": `GateRequestModal_content__FuQ4l`,
	"section": `GateRequestModal_section__mG1TX`,
	"sectionTitle": `GateRequestModal_sectionTitle__62dN7`,
	"sectionReason": `GateRequestModal_sectionReason__ZFGqV`,
	"required": `GateRequestModal_required__fBH2m`,
	"infoGrid": `GateRequestModal_infoGrid__sg0pR`,
	"label": `GateRequestModal_label__MzyO9`,
	"value": `GateRequestModal_value__nAxEB`,
	"fieldColumn": `GateRequestModal_fieldColumn__I7siU`,
	"timeGrid": `GateRequestModal_timeGrid__4GcWL`,
	"roundedInput": `GateRequestModal_roundedInput__8+fV9`,
	"footer": `GateRequestModal_footer__K7FMv`,
	"cancelBtn": `GateRequestModal_cancelBtn__GKDBk`,
	"submitBtn": `GateRequestModal_submitBtn__-HW5K`,
	"leaveParent": `GateRequestModal_leaveParent__yyeDT`
};
export default ___CSS_LOADER_EXPORT___;
